/**
 * Highest playback rate a video may run at while the company has turned faster video playback
 * off (sc-5745).
 */
export const MAX_ALLOWED_PLAYBACK_RATE = 1;

/** The rates our own control bar offers, mirroring the set Chrome's native menu provides. */
export const PLAYBACK_RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] as const;
